import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'PARTS_EQUIPMENTS_WORK_ORDERS'
);
export const PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CONSTANTS
);
